import React from 'react';
import { MenuContentTemplate } from '../../components';
import { MySettingsPortalRoutes, menus } from './mySettingRouter';

export const MySettings = ({ navigation }: any) => {
  return (
    <MenuContentTemplate navigation={navigation} menus={menus} menuTitle="My Settings">
      <MySettingsPortalRoutes />
    </MenuContentTemplate>
  );
};
